import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c21c865"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c21c865')) {
      api.createRecord('3c21c865', component.options)
    } else {
      api.reload('3c21c865', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c21c865", function () {
      api.rerender('3c21c865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjUpload/index.vue"
export default component.exports